import Phaser from "phaser";

export class CharacterAnimator {
  private lastDirection = "s";
  private lockedUntil = 0;

  constructor(
    private readonly sprite: Phaser.GameObjects.Sprite,
    private readonly profileId: string,
  ) {}

  updateLocomotion(direction: string, moving: boolean, now: number): void {
    if (direction) this.lastDirection = direction;
    if (now < this.lockedUntil) return;
    this.play(moving ? "walk" : "idle", this.lastDirection, true);
  }

  playAction(state: string, durationMs: number, direction = this.lastDirection): void {
    this.lastDirection = direction;
    this.lockedUntil = this.sprite.scene.time.now + durationMs;
    this.play(state, direction, false);
  }

  private play(state: string, direction: string, ignoreIfPlaying: boolean): void {
    const key = `${this.profileId}-${state}-${direction}`;
    if (!this.sprite.scene.anims.exists(key)) {
      throw new Error(`Brak animacji produkcyjnej: ${key}`);
    }
    this.sprite.play(key, ignoreIfPlaying);
  }
}
